import { CheckCircleIcon, CloseIcon } from '@chakra-ui/icons';
import {
    Button,
    FormControl,
    Flex,
    Heading,
    Input,
    Stack,
    Text,
    
    Box,
    FormLabel,
  } from '@chakra-ui/react';
import { useCallback, FormEvent, useState } from 'react';
import {  useNavigate, useParams } from 'react-router-dom';
import { ERRORS } from '../errors';
import { ApiError } from '../fetch';
import {  resetPassword } from '../fetch/auth';
import { ROUTES } from '../routes';


  
export const ResetPasswordForm = ()=>{

    const [password, setPassword] = useState('')
    const [rePassword, setRePassword] = useState('')
    const { token: resetToken } = useParams();
    const [resOk,setResOk]=useState(false);
    const [error, setError] = useState('');
    const navigate = useNavigate();
    

    const requestReset = useCallback(
        async (e: FormEvent | MouseEvent) => {
          e.preventDefault();
          setResOk(false);
          if (!isValidPassword(password)){               
            setError(ERRORS.INVALID_PASSWORD);
            return;
          }
          if (password!==rePassword){               
            setError('كلمتا المرور غير متطابقتين');
            return;
          }
          try{
           await resetPassword(password,resetToken!);
           setResOk(true);
           setError('');
          }
          catch(e){
            setError((e as ApiError).message);
          }
        }
        ,[password]);


        const isValidPassword=(pass: string): boolean=>{
          return(/[A-Z]/.test(pass) &&
                 /[a-z]/.test(pass) &&
                 /[0-9]/.test(pass) &&
                 pass.length>=6 &&
                 pass.length<=32);
        }
        
    return (
      
    <>
 
        <form onSubmit={requestReset} dir='rtl' >
      
      <Flex
        minH={'100vh'}
        
        justify={'center'}
        bg='gray.50'>
        <Stack spacing={8} mx={'auto'} maxW={'sm'} py={12} px={6}>
          <Stack align={'center'}>
            <Heading fontSize={'4xl'}>تغيير كلمة المرور</Heading>
           
          </Stack>
          <Box
            rounded={'lg'}
            bg={'white'}
            boxShadow={'lg'}
            p={8}>
            <Stack spacing={4}>           
  
              <FormControl id="password" isDisabled={resOk}>
                <FormLabel>كلمة المرور الجديدة</FormLabel>
                <Input type="password" value={password} onChange={e => setPassword(e.target.value)}/>
                <Text color={'red.500'} fontSize={'sm'}>{ERRORS.INVALID_PASSWORD}</Text>
              </FormControl>
              <FormControl id="repassword" isDisabled={resOk}>
                <FormLabel>تأكيد كلمة المرور</FormLabel>
                <Input type="password" value={rePassword} onChange={e => setRePassword(e.target.value)}/>
              </FormControl>
              <Stack spacing={10}>
                       
                <Button
                type='submit' 
                  bg={'blue.400'}
                  color={'white'}
                  _hover={{
                    bg: 'blue.500',
                  }}
                  isDisabled={resOk}
                  >
                  حفظ كلمة المرور
                </Button>
               
              </Stack>
            
              {resOk &&
        <Flex direction={'column'} justifyContent={'center'} pt={15}>
        <Stack justifyContent={'center'} direction={'row'} spacing={2}>
          <CheckCircleIcon boxSize={'20px'} color={'green.500'} />                           
          <Text color="green">تم حفظ كلمة المرور الجديدة</Text>               
        </Stack>             
       <Button 
       marginTop={15}
       bg={'red.400'}
        color={'white'}
          _hover={{
           bg: 'blue.500',
         }} onClick={()=>{navigate(ROUTES.SIGN_IN)}}>تسجيل الدخول</Button>
       </Flex>}
        
              {!!error &&
               <Stack justifyContent={'center'} direction={'row'} spacing={2}>
                <CloseIcon boxSize={'20px'} color={'white'} />
               <Text color="red.700">{error}</Text>             
               </Stack>
               }
            </Stack>
          </Box>
        </Stack>
       
      </Flex>
      </form>

      </>
    );
  }
  